import { createGlobalStyle, css } from 'styled-components';
export const FooterWedge = createGlobalStyle `
    :root {
        --BottomWedge_Height: 4.75rem;
        
         @media (min-width: 32.5rem) {
            --BottomWedge_Height: 5.75rem;
        }
    }
`;
export const FooterSharedStyles = css `
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 1;
    box-sizing: border-box;
    min-height: 3.75rem;
    padding: 1.25rem 1rem;
    pointer-events: none;

    a, button {
        pointer-events: all;
    }

    @media (min-width: 32.5rem) {
        padding: 2rem;
    }
`;
